export const baseErrors: any = {
  0: "Success",
  1: "Error",
  200: "Success",
  401: "Unauthorized",
  429: "TooManyRequest",
  500: "ServerError",
  10000: "Unknown",
  10001: "Validation",
  10002: "DbValidation",
  10003: "AllreadyExist",
  10004: "NotPermission",
  10005: "IncorrectOtp",
  10006: "TooManyAttemps",
  10007: "ExpiredOtp",
  10008: "IncorrectPassword",
  10009: "BadRequest",
  10010: "OrganizationExist",
  10011: "OrganizationNotFound",
  10020: "UserAllreadyExist",
  10021: "UserNotFound",
  10023: "SalaryAllreadyPaid",
  10124: "GroupRoomFilled",
  10030: "BranchExist",
  10031: "BranchNotFound",
  10084: "StudentHasActiveGroups",
  10085: "StudentHasUnpaids",
  10086: "StudentHasUnpaidAttendances",
  10040: "CourseExist",
  10382: "Holiday",
  10041: "CourseNotFound",
  10042: "CourseDayNotFound",
  10043: "CourseShiftNotFound",
  10044: "HasDependantGroups",
  10050: "SectionExist",
  10051: "SectionNotFound",
  10060: "RoleExist",
  10061: "RoleNotFound",
  10070: "LevelExist",
  10071: "LevelNotFound",
  10072: "HasEmployee",
  10080: "StudentExist",
  10088: "MoreThanLimit",
  10081: "StudentNotFound",
  10082: "StudentAllreadyInGroup",
  10083: "StudentNotInGroup",
  10087: "StudentHasActiveOrders",
  10090: "CategoryExist",
  10091: "CategoryNotFound",
  10100: "SurveyExist",
  10101: "SurveyNotFound",
  10110: "InvalidFileType",
  10111: "FileNotUploaded",
  10120: "GroupExist",
  10121: "GroupNotFound",
  10122: "GroupRoomBusy",
  10123: "GroupTeacherBusy",
  10130: "RoomExist",
  10131: "RoomNotFound",
  10132: "RoomHasGroup",
  10140: "BranchSettingsExist",
  10141: "BranchSettingsNotFound",
  10150: "OrderExist",
  10151: "OrderNotFound",
  10160: "NewsExist",
  10161: "NewsNotFound",
  10170: "AttendaceTimeNotMatch",
  10180: "ShiftExist",
  10181: "ShiftNotFound",
  10190: "TeacherSalaryExist",
  10191: "TeacherSalaryNotFound",
  10192: "HasLinkedEmployee",
  10201: "CommentNotFound",
  10210: "ReferralExist",
  10211: "ReferralNotFound",
  10220: "LessonExist",
  10221: "LessonNotFound",
  10222: "LessonPassed",
  10223 :"AttendanceTimeHasPassed",
  10062: "ExistEmployee",
  10318: "employeeBusy",
  10450: "AllreadyExist",
  10231: "TransactionNotFound",
  10240: "ParentExist",
  10241: "ParentNotFound",
  10252: "CantBeNegative",
  10314: "AlreadyExist",
  10352: "InvalidBallTask",
  10420: "OnlineCategoryExist",
  10422: "OnlineCategoryHasCourse",
  10701: "ProductOrderFound",
  10092: "PhoneNumberNotVefified",
  10096: "CannotAttend"
};
